// ─── ¿Cuánto de una orden de producción ya se entregó? ───────────────────────
// Las pestañas del listado de OPs («En proceso» y «Remisionadas») no se pueden
// decidir por el estado de la orden: en producción todas las vigentes están
// «completada» (se completa el documento al confirmarlo, no al entregar). Lo
// que dice si una OP ya salió es lo que llevan sus REMISIONES contra lo que
// pidió, artículo por artículo.
//
// Cuenta una remisión que entregó: ni la cancelada ni el borrador (un borrador
// todavía no ha sacado nada de la bodega; el kardex se mueve al completarla).
// Es puro: las remisiones llegan por parámetro.

const norm = (s) => String(s || "").trim().toLowerCase();
const num = (v) => { const n = Number(String(v ?? "").replace(/,/g, ".")); return Number.isFinite(n) ? n : 0; };

export const remisionEntrego = (rc) => !!rc && rc.estado !== "cancelada" && rc.estado !== "borrador";

export function entregaDeOP(op, remisiones) {
  const deOP = (remisiones || []).filter(rc =>
    rc && rc._origen && rc._origen.tipo === "OP" && rc._origen.id === op.id && remisionEntrego(rc));
  // Por ARTÍCULO, no por línea: una orden puede traer el mismo artículo en dos
  // líneas, y sumar cada remisión contra cada línea lo contaría dos veces.
  const pedido = new Map(), entregado = new Map();
  (op.items || []).forEach(it => {
    const k = norm(it.articulo);
    pedido.set(k, (pedido.get(k) || 0) + num(it.cantidad));
  });
  deOP.forEach(rc => (rc.items || []).forEach(it => {
    const k = norm(it.articulo);
    if (pedido.has(k)) entregado.set(k, (entregado.get(k) || 0) + num(it.cantidad));
  }));
  let pedidoUds = 0, entregadoUds = 0;
  for (const [k, p] of pedido) {
    if (p <= 0) continue;
    pedidoUds += p;
    entregadoUds += Math.min(entregado.get(k) || 0, p); // lo de más en un artículo no tapa lo que falta en otro
  }
  const estado = pedidoUds <= 0
    ? (deOP.length ? "entregada" : "sin_entregar")
    : entregadoUds + 0.001 >= pedidoUds ? "entregada"
    : entregadoUds > 0 ? "parcial" : "sin_entregar";
  return {
    estado, pedidoUds, entregadoUds, remisiones: deOP.length,
    pct: pedidoUds > 0 ? Math.round(Math.min(1, entregadoUds / pedidoUds) * 100) : (estado === "entregada" ? 100 : 0)
  };
}

// A qué pestaña va: «remisionadas» si ya se entregó toda; «en_proceso» si está
// vigente y falta entregar (también la parcial). El borrador y la cancelada no
// son trabajo en curso: solo se ven en «Todas».
export function pestanaDeOP(op, entrega) {
  if (!op || op.estado === "cancelada" || op.estado === "borrador") return null;
  return entrega.estado === "entregada" ? "remisionadas" : "en_proceso";
}

export const PESTANAS_OP = [
  { id: "todas", label: "Todas", icon: "📋" },
  { id: "en_proceso", label: "En proceso", icon: "⚙️" },
  { id: "remisionadas", label: "Remisionadas", icon: "📮" }
];
